import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { forgotPasswordApi } from "../../end-points/forgotPassword"

const initialState = {
  loading: false,
  error: null,
  success: false,
};

export const forgotPassword = createAsyncThunk(
  "forgotPass/forgotPassword",
  async(payload, thunkAPI) => {
    try {
      const response = await forgotPasswordApi(payload);
      console.log("response", response);
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

const forgotPasswordSlice = createSlice({
  name: "forgotPass",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(forgotPassword.pending, (state) => {
      console.log("Loading...", state);
      state.loading = true;
    })
    builder.addCase(forgotPassword.fulfilled, (state, action) => {
      console.log("Success...", state, action);
      state.loading = false;
    })
    builder.addCase(forgotPassword.rejected, (state, action) => {
      console.log("Error", state, action);
      state.loading = false;
    })
  }
});

export default forgotPasswordSlice.reducer;